module.exports = __webpack_public_path__ + "img/CS-UL-I_Overview-Spare_2.7c4c893d.jpg";